// extracted by mini-css-extract-plugin
export default {"loginBanner":"i80gqL33odqix0eWC1JF","content":"VK3hZdgub8i7hx3UPPSj","message":"WbWokH6VLws_48B62B8a","loginButtonContainer":"xZJ_4A1P7vgw5JIRjNEJ"};